import { render } from "./AlertPopup.vue?vue&type=template&id=3fd04cba&scoped=true&ts=true"
import script from "./AlertPopup.vue?vue&type=script&lang=ts"
export * from "./AlertPopup.vue?vue&type=script&lang=ts"

import "./AlertPopup.vue?vue&type=style&index=0&id=3fd04cba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd04cba"]])

export default __exports__